import { render, staticRenderFns } from "./1ModeloBase.vue?vue&type=template&id=625265ef&scoped=true"
import script from "./1ModeloBase.vue?vue&type=script&lang=js"
export * from "./1ModeloBase.vue?vue&type=script&lang=js"
import style0 from "./1ModeloBase.vue?vue&type=style&index=0&id=625265ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625265ef",
  null
  
)

export default component.exports